import React from 'react'
import { get, isArray } from 'lodash-es'
import { Locale, Translation } from 'locale'
import { getErrorMessagesByField } from 'model'
import { getTooltipContent, Tooltip } from 'view/components/tooltip'
import { ErrorBar, ErrorNarrative, ParseResultLoading, SuccessBar } from '../upload/parseResultPanelStyles'
import { iconSet } from 'view/components/icons'
import { SpreadsheetParseResult } from './model'

export type ParseResultItemGetter = (parseResult: SpreadsheetParseResult) => []

export interface ParseResultPanelProps<TResult = any> {
  parseResult: TResult
  itemField: string | any[]
  successMessage: Translation
  errorMessage: Translation
  errorNarrative?: Translation
}

const ParseResultLoaded: React.FunctionComponent<ParseResultPanelProps> = props => {
  const { parseResult, itemField, successMessage, errorMessage, errorNarrative } = props

  if (parseResult === null) {
    throw new Error('ParseResult not specified')
  }

  const items = isArray(itemField) ? itemField : get(parseResult, itemField)
  const successItemCount = items.length
  const errorItemCount = parseResult.rows.length - items.length
  const errorMessages = getErrorMessagesByField(parseResult.issues)
  const errorCount = errorMessages.length

  return (
    <>
      {successItemCount > 0 ? (
        <SuccessBar data-test-id="SpreadsheetParseResultSuccessMessage">
          {iconSet.tickIcon}
          {Locale.translate(successMessage, { count: successItemCount })}
        </SuccessBar>
      ) : null}
      {errorItemCount > 0 || errorMessages.length > 0 ? (
        <>
          <Tooltip tooltip={getTooltipContent(errorMessages)}>
            <ErrorBar data-test-id="SpreadsheetParseResultErrorMessage">
              {iconSet.warningIcon}
              {Locale.translate(errorMessage, { count: errorItemCount, errorCount })}
            </ErrorBar>
          </Tooltip>
          {errorNarrative ? <ErrorNarrative>{Locale.translate(errorNarrative)}</ErrorNarrative> : null}
        </>
      ) : null}

      {successItemCount === 0 && errorCount === 0 && errorMessages.length === 0 ? (
        <ErrorBar data-test-id="SpreadsheetParseResultErrorMessage">
          {Locale.translate(Translation.SC_UPLOAD_ERROR_NARRATIVE_MAPPING_NO_ITEMS)}
        </ErrorBar>
      ) : null}
    </>
  )
}

export const ParseResultPanel = (props: ParseResultPanelProps) => {
  const { parseResult } = props
  return <div>{parseResult ? <ParseResultLoaded {...props} /> : <ParseResultLoading data-test-id="ParseResultLoading" />}</div>
}
